module.exports = __webpack_public_path__ + "img/report-tip2.7b44596b.png";